import React, { useEffect } from 'react';
import PageShell from '../common/PageShell.jsx';
import PageHero from '../common/PageHero.jsx';

const Partner = () => {
  useEffect(() => {
    document.title = 'Partner With Us | Eco World Capital';
  }, []);

  const opportunities = [
    { title: 'Investment Partner', earning: '50 TO 65%', desc: 'We share profit 50 to 65% investor partners.' },
    { title: 'Franchise Partnership', earning: '5 TO 35% on target basis', desc: 'We share 5 TO 35% on target basis to franchise partners.' },
    { title: 'Strategy Partner', earning: '25-50%', desc: 'We share 25-50% share of profit to Strategy partner.' },
    { title: 'Performance Based employment', earning: '5000 to 300000 P.M.', desc: 'We provide salary to our employee minimum 5000 to 300000 P.M. on performance basis.' },
  ];

  return (
    <PageShell>
      <PageHero
        badge="ECO WORLD CAPITAL (EWC)"
        title="Partner With Us"
        subtitle={
          <>
            Available opportunities with Eco World Capital (EWC). You can work from home or anywhere and earn{' '}
            <span className="text-brand-gold">5-35% of our profit</span>. We share 5-35% of our profit on target basis from our profit.
          </>
        }
      />

      <section className="py-12 px-6 md:px-12 max-w-4xl mx-auto text-center">
        <div className="bg-black/10 p-8 rounded-3xl border border-white/20 backdrop-blur-md">
          <p className="text-lg text-brand-cream leading-relaxed font-medium mb-4">
            EWC offers innovative partnership models designed around performance metrics and targeted results. Whether you're seeking franchise opportunities, strategic partnerships, or employment, our approach focuses on measurable outcomes.
          </p>
          <p className="text-lg text-brand-cream leading-relaxed font-medium">
            We believe in rewarding excellence through our performance-based compensation structure, ensuring all stakeholders are aligned toward common goals and shared success.
          </p>
        </div>
      </section>

      <section className="py-24 px-6 md:px-12 bg-black/10 border-y border-white/20 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            {opportunities.map((item, idx) => (
              <div
                key={idx}
                className="glass-card p-10 hover:bg-brand-cream/20 hover:border-brand-gold-light/50 transition-all duration-300 shimmer-hover flex flex-col md:flex-row items-center gap-8 text-center md:text-left"
              >
                <div className="relative z-10 shrink-0">
                  <div className="w-24 h-24 bg-gradient-to-br from-brand-gold to-brand-gold-light rounded-2xl flex items-center justify-center shadow-inner border border-brand-cream/50 text-brand-primary font-black text-3xl">
                    ✦
                  </div>
                </div>
                <div className="relative z-10">
                  <h3 className="text-2xl font-extrabold text-brand-gold tracking-wide mb-2">{item.title}</h3>
                  <div className="inline-block bg-brand-cream text-brand-primary font-extrabold px-4 py-1 rounded-full text-sm tracking-wider mb-4 shadow-sm">
                    {item.earning}
                  </div>
                  <p className="text-sm text-brand-cream-muted leading-relaxed font-medium">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 px-6 md:px-12 max-w-4xl mx-auto">
        <div className="space-y-4">
          <p className="text-base font-extrabold text-brand-gold-light leading-relaxed border border-brand-gold-light/30 bg-brand-cream/10 rounded-2xl py-4 px-6 backdrop-blur-sm">
            NOTE: YOU CAN APPOINT SUB FRANCHISE PARTNER OR DSA UNDER YOU AND PART PROFIT FROM YOUR NET PROFIT.
          </p>
          <p className="text-base font-extrabold text-brand-cream-muted leading-relaxed border border-brand-cream/20 bg-brand-cream/5 rounded-2xl py-4 px-6 backdrop-blur-sm">
            FRANCHISE PARTNERS ARE ELIGIBLE FOR THEIR REFFERED CLIENTS ONLY. NOT FROM ALL EWC OTHER FRANCHISE PARTNERS AND THEIR CLIENTS.
          </p>
        </div>
      </section>
    </PageShell>
  );
};

export default Partner;
